module.exports = __webpack_public_path__ + "static/media/avatar-05@2x.7a4fa96e.png";